import React, { Component } from 'react'
import PropTypes from 'prop-types'

import LogoContainer from './LogoContainer'

import '../styles/Header.css'

class Header extends Component {
  render () {
    const {
      transparent,
      bg
    } = this.props

    const classTransparent = transparent ? 'transparent' : ''
    const classBg = bg || ''

    return (
      <div className={`Header ${classTransparent} ${classBg}`}>
        <LogoContainer />
      </div>
    )
  }
}

Header.propTypes = {
  transparent: PropTypes.bool
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js